import { GeometryApi, getFeatureAcres } from '@cibo/core'
import { useQueries } from '@tanstack/react-query'
import { MultiPolygon } from 'geojson'

const QUERY_KEY = 'fips_acreage'

export const useGeometryAcres = (geometryIds: string[]) => {
  const geometries = useQueries({
    queries: geometryIds.map(id => {
      return {
        queryKey: [QUERY_KEY, id],
        queryFn: () => GeometryApi.getGeometry(id),
      }
    }),
  })
  if (!geometries.find(a => a.isLoading)) {
    const features = geometries.map(query => query.data).filter(Boolean)
    return {
      isLoading: false,
      data: getFeatureAcres(features as MultiPolygon[]),
    }
  } else {
    return { isLoading: true, data: 0 }
  }
}
